// Client-side cluster configuration fallbacks
// These should match the server-side defaults in server/clusterConfig.js

export const getDefaultClusterConfig = () => {
  return [
    { key: 'SOLO', display: 'Solos' },
    { key: 'DUO', display: 'Duos' },
    { key: '3MAN', display: '3/6 Man' },
    { key: '100', display: '2/6 Man 100x' }
  ];
};

export const getDefaultClusterOrder = () => {
  return ['SOLO', 'DUO', '3MAN', '100'];
}; 